import { render, staticRenderFns } from "./VirtualGiftsModal.vue?vue&type=template&id=1ac2b3de&"
import script from "./VirtualGiftsModal.vue?vue&type=script&lang=js&"
export * from "./VirtualGiftsModal.vue?vue&type=script&lang=js&"
import style0 from "./VirtualGiftsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports